import * as React from 'react';
import classnames from 'classnames';
import FilterWrapper from "../../FilterWrapper";
import { RadioFacet } from "./RadioFacet";
import { CheckboxFacet } from "./CheckboxFacet";
import { DropdownFacet } from "./DropdownFacet";
import { Facet } from "@elastic/react-search-ui";

function CheckboxesFilter({label, attribute, initialFacetValues, isFirstFacet}) {
  return (
    <FilterWrapper label={label} attribute={attribute} kind='checkboxes'>
      <Facet field={attribute} label={label} filterType='any' show={500} view={CheckboxFacet} initialFacetValues={initialFacetValues} isFirstFacet={isFirstFacet}/>
    </FilterWrapper>
  );
}

function DropdownFilter({label, attribute, initialFacetValues, isFirstFacet}) {
  return (
    <FilterWrapper label={label} attribute={attribute} kind='dropdown'>
      <Facet field={attribute} label={label} filterType='any' show={500} view={DropdownFacet} initialFacetValues={initialFacetValues} isFirstFacet={isFirstFacet}/>
    </FilterWrapper>
  );
}

function RadioButtonsFilter({label, attribute, initialFacetValues, isFirstFacet}) {
  return (
    <FilterWrapper label={label} attribute={attribute} kind='radio-buttons'>
      <Facet field={attribute} label={label} filterType='any' show={500} view={RadioFacet} initialFacetValues={initialFacetValues} isFirstFacet={isFirstFacet}/>
    </FilterWrapper>
  );
}

export default function Filter(props) {
  const {config, isFirstFacet, allValues = {}} = props;
  const {
    attribute = null,
    label,
    kind,
  } = config;

  if (!attribute) {
    return null;
  }

  const initialFacetValues = allValues[attribute] || [];

  switch (kind) {
    case 'radio':
      return <RadioButtonsFilter
               label={label}
               attribute={attribute}
               initialFacetValues={initialFacetValues}
               isFirstFacet={isFirstFacet}/>;
    case 'checkboxes':
      return <CheckboxesFilter
               label={label}
               attribute={attribute}
               initialFacetValues={initialFacetValues}
               isFirstFacet={isFirstFacet}/>;
    case 'dropdown':
      return <DropdownFilter
               label={label}
               attribute={attribute}
               initialFacetValues={initialFacetValues}
               isFirstFacet={isFirstFacet}/>;
    default:
      return null;
  }
}
